module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"sections-wrapper\" class=\"section-wrapper col-")
    ; __append(escapeFn( width ))
    ; __append("\" group=\"")
    ; __append(escapeFn( group ))
    ; __append("\">\n    <h3>")
    ; __append(escapeFn( group ))
    ; __append("</h3>\n\n    <div class='profile-tools sections' name=\"sections\"></div>\n</div>\n")
  }
  return __output.join("");

}